import dayjs from 'dayjs'

/**
 * Mock Sentry Issues Data
 * Matches the actual API response structure
 */
export const mockSentryIssues = {
  success: true,
  issues: [
    {
      id: '6843177808',
      title: 'AxiosError: Network Error',
      culprit: '/linehaul/trips-dashboard/in-transit',
      status: 'unresolved',
      level: 'error',
      type: 'error',
      metadata: {
        title: 'AxiosError',
        value: 'Network Error',
        type: 'AxiosError',
        filename: 'axios/lib/core/Axios.js',
        function: 'handleError',
        in_app_frame_mix: 'system-only',
      },
      numComments: 0,
      userCount: 5,
      count: 23,
      firstSeen: dayjs().subtract(3, 'months').toISOString(),
      lastSeen: dayjs().subtract(2, 'hours').toISOString(),
      permalink: 'https://sentry.io/organizations/daylight/issues/6843177808/',
      shortId: 'APEX-CLIENT-8FN',
      project: {
        id: '4507465295659008',
        name: 'apex-client',
        slug: 'apex-client',
        platform: 'javascript-react',
      },
      assignedTo: null,
      isBookmarked: false,
      isSubscribed: false,
      isUnhandled: true,
      hasSeen: false,
      annotations: [],
      logger: '',
      priority: 'high',
      filtered: {
        count: 23,
        userCount: 5,
        firstSeen: dayjs().subtract(3, 'months').toISOString(),
        lastSeen: dayjs().subtract(2, 'hours').toISOString(),
      },
      lifetime: {
        count: 45,
        userCount: 12,
        firstSeen: dayjs().subtract(6, 'months').toISOString(),
        lastSeen: dayjs().subtract(2, 'hours').toISOString(),
      },
      enrichedEnvironment: 'PROD',
    },
    {
      id: '6843177809',
      title: 'Request failed with status code 404',
      culprit: '/linehaul/load-board/shipments',
      status: 'unresolved',
      level: 'error',
      type: 'error',
      metadata: {
        title: 'AxiosError',
        value: 'Request failed with status code 404',
        type: 'AxiosError',
        filename: 'axios/lib/adapters/xhr.js',
        function: 'handleResponse',
        in_app_frame_mix: 'system-only',
      },
      numComments: 2,
      userCount: 8,
      count: 156,
      firstSeen: dayjs().subtract(1, 'month').toISOString(),
      lastSeen: dayjs().subtract(30, 'minutes').toISOString(),
      permalink: 'https://sentry.io/organizations/daylight/issues/6843177809/',
      shortId: 'APEX-CLIENT-9GH',
      project: {
        id: '4507465295659008',
        name: 'apex-client',
        slug: 'apex-client',
        platform: 'javascript-react',
      },
      assignedTo: {
        id: 'user123',
        name: 'John Doe',
        email: 'john.doe@example.com',
      },
      isBookmarked: true,
      isSubscribed: true,
      isUnhandled: false,
      hasSeen: true,
      annotations: [],
      logger: 'axios',
      priority: 'high',
      filtered: {
        count: 156,
        userCount: 8,
        firstSeen: dayjs().subtract(1, 'month').toISOString(),
        lastSeen: dayjs().subtract(30, 'minutes').toISOString(),
      },
      lifetime: {
        count: 234,
        userCount: 15,
        firstSeen: dayjs().subtract(4, 'months').toISOString(),
        lastSeen: dayjs().subtract(30, 'minutes').toISOString(),
      },
      enrichedEnvironment: 'PROD',
    },
    {
      id: '6843177810',
      title: 'TypeError: Cannot read properties of undefined',
      culprit: '/inbound/planning',
      status: 'unresolved',
      level: 'error',
      type: 'error',
      metadata: {
        title: 'TypeError',
        value: "Cannot read properties of undefined (reading 'map')",
        type: 'TypeError',
        filename: 'src/components/Planning.tsx',
        function: 'PlanningComponent',
        in_app_frame_mix: 'in-app-only',
      },
      numComments: 0,
      userCount: 3,
      count: 12,
      firstSeen: dayjs().subtract(2, 'weeks').toISOString(),
      lastSeen: dayjs().subtract(1, 'hour').toISOString(),
      permalink: 'https://sentry.io/organizations/daylight/issues/6843177810/',
      shortId: 'APEX-CLIENT-1RP',
      project: {
        id: '4507465295659008',
        name: 'apex-client',
        slug: 'apex-client',
        platform: 'javascript-react',
      },
      assignedTo: null,
      isBookmarked: false,
      isSubscribed: false,
      isUnhandled: true,
      hasSeen: false,
      annotations: [],
      logger: '',
      priority: 'medium',
      filtered: {
        count: 12,
        userCount: 3,
        firstSeen: dayjs().subtract(2, 'weeks').toISOString(),
        lastSeen: dayjs().subtract(1, 'hour').toISOString(),
      },
      lifetime: {
        count: 18,
        userCount: 5,
        firstSeen: dayjs().subtract(1, 'month').toISOString(),
        lastSeen: dayjs().subtract(1, 'hour').toISOString(),
      },
      enrichedEnvironment: 'LOCAL',
    },
    {
      id: '6843177811',
      title: 'Request timeout exceeded',
      culprit: '/back-office/rate-quote',
      status: 'unresolved',
      level: 'warning',
      type: 'error',
      metadata: {
        title: 'TimeoutError',
        value: 'Request timeout exceeded',
        type: 'TimeoutError',
        filename: 'axios/lib/core/Axios.js',
        function: 'request',
        in_app_frame_mix: 'system-only',
      },
      numComments: 1,
      userCount: 2,
      count: 8,
      firstSeen: dayjs().subtract(1, 'week').toISOString(),
      lastSeen: dayjs().subtract(3, 'hours').toISOString(),
      permalink: 'https://sentry.io/organizations/daylight/issues/6843177811/',
      shortId: 'APEX-CLIENT-ARD',
      project: {
        id: '4507465295659008',
        name: 'apex-client',
        slug: 'apex-client',
        platform: 'javascript-react',
      },
      assignedTo: null,
      isBookmarked: false,
      isSubscribed: false,
      isUnhandled: false,
      hasSeen: true,
      annotations: [],
      logger: 'axios',
      priority: 'low',
      filtered: {
        count: 8,
        userCount: 2,
        firstSeen: dayjs().subtract(1, 'week').toISOString(),
        lastSeen: dayjs().subtract(3, 'hours').toISOString(),
      },
      lifetime: {
        count: 10,
        userCount: 3,
        firstSeen: dayjs().subtract(2, 'weeks').toISOString(),
        lastSeen: dayjs().subtract(3, 'hours').toISOString(),
      },
      enrichedEnvironment: 'QA',
    },
    {
      id: '6843177812',
      title: 'ChunkLoadError: Loading chunk failed',
      culprit: '/outbound/trailer-hub',
      status: 'unresolved',
      level: 'error',
      type: 'error',
      metadata: {
        title: 'ChunkLoadError',
        value: 'Loading chunk 5 failed',
        type: 'ChunkLoadError',
        filename: 'webpack/runtime/ensure chunk',
        function: '__webpack_require__.e',
        in_app_frame_mix: 'system-only',
      },
      numComments: 0,
      userCount: 10,
      count: 45,
      firstSeen: dayjs().subtract(5, 'days').toISOString(),
      lastSeen: dayjs().subtract(15, 'minutes').toISOString(),
      permalink: 'https://sentry.io/organizations/daylight/issues/6843177812/',
      shortId: 'APEX-CLIENT-BHM',
      project: {
        id: '4507465295659008',
        name: 'apex-client',
        slug: 'apex-client',
        platform: 'javascript-react',
      },
      assignedTo: null,
      isBookmarked: false,
      isSubscribed: false,
      isUnhandled: true,
      hasSeen: false,
      annotations: [],
      logger: '',
      priority: 'medium',
      filtered: {
        count: 45,
        userCount: 10,
        firstSeen: dayjs().subtract(5, 'days').toISOString(),
        lastSeen: dayjs().subtract(15, 'minutes').toISOString(),
      },
      lifetime: {
        count: 67,
        userCount: 18,
        firstSeen: dayjs().subtract(2, 'weeks').toISOString(),
        lastSeen: dayjs().subtract(15, 'minutes').toISOString(),
      },
      enrichedEnvironment: 'PROD',
    },
  ],
  pagination: {
    nextCursor: null,
    hasMore: false,
    recordCount: 5,
  },
  'x-hits': 5,
}
